import script from "./HeaderUserProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderUserProfile.vue?vue&type=script&setup=true&lang=js"

import "./HeaderUserProfile.vue?vue&type=style&index=0&id=29559b65&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29559b65"]])

export default __exports__